import {Component, OnInit, ViewChild} from '@angular/core';
import {PatientCaseWorkItemFormDataModel} from '../../models/forms/data/patient-case-work-item-form-data.model';
import {EnumValidValueItemModel} from '../../models/enum/enum-valid-value-item.model';
import {StaticDataService} from '../../services/static-data.service';
import {PainHistoryService} from '../../services/form/pain-history.service';
import {Globals} from '../../globals';
import {PainHistoryPatientFormsModel} from './models/pain-history-patient-forms.model';
import {TdoTableV2Component} from '../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {DataPatientCaseWorkItemFormToothModel} from '../../models/teeth/data-patient-case-work-item-form-tooth.model';
import {TdoTableSelectionEvent} from '../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {FormItemDataModel} from '../../models/forms/data/form-item-data.model';
import {child} from 'winston';
import {FormsGlobals} from '../../models/forms/forms.enum';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {PainHistorySleuthWizardDialogComponent} from './dialogs/pain-history-sleuth-wizard-dialog/pain-history-sleuth-wizard-dialog.component';
import {NotesService} from '../../services/notes.service';
import {TdoNoteQueryModel} from '../../main-interface/controls/tdo-notes/models/tdo-note-query.model';
import {TdoNoteAssociatedObject, TdoNoteSaveModel} from '../../main-interface/controls/tdo-notes/models/tdo-note-save-model';
import {MessagingConstants} from '../../models/MessagingConstants';
import {MessagingService} from '../../services/messaging.service';
import {PainEndoDataModel} from './models/pain-endo-data.model';
import {PainEndoDetailDataModel} from './models/pain-endo-detail-data.model';
//import {FormControlEnum} from '../../models/enum/forms/form-control.enum';

@Component({
  selector: 'app-pain-history',
  templateUrl: './pain-history.component.html',
  styleUrls: ['./pain-history.component.scss']
})
export class PainHistoryComponent implements OnInit {
  @ViewChild('patientPainTable') patientPainTable: TdoTableV2Component;
  @ViewChild('detailTable') detailTable: TdoTableV2Component;


  enumFormControls_Label         = '00000001-1000-0000-0000-000000000006';
  enumFormControls_Label45      = '00000001-1000-0000-0000-000000000018';

  painForms: PainHistoryPatientFormsModel[] = [];
  selectedPainForm: PainHistoryPatientFormsModel;
  selectedPainFormDataItems: FormItemDataModel[] = [];

  // painModels: DataPainEndoModel[] = [];
  selectedPainModel: PainEndoDataModel;

  formResultsString: string = '';
  formResultsStringForNotes: string = '';

  characterOfPainEnums: EnumValidValueItemModel[] = [];
  toothSleuthSeqEnums: EnumValidValueItemModel[] = [];
  painReliefEnums: EnumValidValueItemModel[] = [];
  nonOdontogenicEnums: EnumValidValueItemModel[] = [];
  ondontogenicWEtiologyEnums: EnumValidValueItemModel[] = [];
  referralPatternsEnums: EnumValidValueItemModel[] = [];

  isFormatAsParagraph: boolean = false;

  constructor(private staticDataService: StaticDataService,
              private dialog: MatDialog,
              private globals: Globals,
              private messagingService: MessagingService,
              public formsGlobals: FormsGlobals,
              private noteService: NotesService,
              private painService: PainHistoryService) { }

  ngOnInit(): void {
    if (this.staticDataService.isReady) {
      this.setupEnums();
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
         this.setupEnums();
        }
      });
    }
  }

  setupEnums() {
    this.characterOfPainEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoPainCharacterOfPain ');
    this.toothSleuthSeqEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoPainToothSleuthSeq');
    this.painReliefEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoPainPainRelief');
    this.nonOdontogenicEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoPainNonOdontogenic');
    this.ondontogenicWEtiologyEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoPainOdontogenicPossibleEtiology');
    this.referralPatternsEnums = this.staticDataService.getValidValueItemsByValidValueName('enumEndoPainReferralPatterns');


    this.painService.getPatientPainHistoryForms(this.globals.currentPatientId).subscribe((res) => {
      this.painForms = res;
      this.selectedPainForm = this.painForms[0];
      this.setNote();
      this.painService.getDoctorFilledPainHistory(this.selectedPainForm.dataPatientCaseWorkItemForm.CaseWorkItemFormsId).subscribe((doctorRes) => {
        this.selectedPainModel = doctorRes;
        this.detailTable.updateData(this.selectedPainModel?.dataPainEndoDetails);
      });

      this.painService.getFormItemsAndResults(this.selectedPainForm.dataPatientCaseWorkItemForm.CaseWorkItemFormsId).subscribe((res1) => {
        //
        this.selectedPainFormDataItems = res1;
        this.parseResults(res1);
      });
      this.patientPainTable.updateData(this.painForms);
    });
  }

  setNote() {
    const noteQueryModel = new TdoNoteQueryModel();
    noteQueryModel.parentObjectName = 'dataPatientCaseWorkItemForms';
    noteQueryModel.objectId = this.selectedPainForm.dataPatientCaseWorkItemForm.CaseWorkItemFormsId;
    noteQueryModel.patientId = this.globals.currentPatientId;
    this.noteService.changeNoteQuery(noteQueryModel);
  }

  getTeeth(dataPatientCaseItemFormTeeth: DataPatientCaseWorkItemFormToothModel[]) {
    /*let teeth = '';
    for (const t of dataPatientCaseItemFormTeeth) {
      teeth += t.Notation + ' ';
    }
    return teeth;*/
    return '';
  }

  onPatientPainSelected(event: TdoTableSelectionEvent) {
    this.selectedPainForm = event.model;
    this.setNote();

    this.painService.getDoctorFilledPainHistory(this.selectedPainForm.dataPatientCaseWorkItemForm.CaseWorkItemFormsId).subscribe((doctorRes) => {
      this.selectedPainModel = doctorRes;
      this.detailTable.updateData(this.selectedPainModel?.dataPainEndoDetails);
    });

    this.painService.getFormItemsAndResults(this.selectedPainForm.dataPatientCaseWorkItemForm.CaseWorkItemFormsId).subscribe((res) => {
      //
      this.selectedPainFormDataItems = res;
      this.parseResults(res);
    });
  }

  getEnumDisplay(result: string) {
    const enu = this.staticDataService.validValueItems.find(p => p.ValidValueItemId.toLowerCase() === result.toLowerCase());
    if (enu) {
      return enu.ItemDisplayValue;
    }
    return '';
  }

  parseResults(formData: FormItemDataModel[]) {
    this.formResultsString = '';
    this.formResultsStringForNotes = '';
    let spaceTokenHtml = '&nbsp;'; //   '<br />';
    let nlcrTokenHtml =  '<br />';

    let spaceToken = ' ' ; // '\r\n';
    let nlcrToken = '\r\n';


    if (this.isFormatAsParagraph) {
      spaceTokenHtml = ' ';
      spaceToken = ' ';
    }

    console.log(formData);


    for (var formItem of formData) {

      this.formResultsString += '<span style="font-weight: 500; color: var(--tdo-primary);"><b>' + formItem.cfgDFormItem.Label + spaceTokenHtml + '</b></span>';
      this.formResultsStringForNotes += formItem.cfgDFormItem.Label + spaceToken;

        if (formItem.dataFormResults && formItem.dataFormResults.length > 0) {
          for (var res of formItem.dataFormResults) {
            let result = '';
            switch (formItem.cfgDFormItem.enumFormControlID) {
              case this.formsGlobals.CONTROL_TEXT_BOX:
                result = formItem.dataFormResults[0].Result;
                break;
              case this.formsGlobals.CONTROL_DATE:
                result = formItem.dataFormResults[0].Result.substring(0, 10);
                break;

              case this.formsGlobals.CONTROL_COMBO_LIST:
              case this.formsGlobals.CONTROL_CHECK_BOX_LIST:
              case this.formsGlobals.CONTROL_RADIO_LIST:
                result = this.getEnumDisplay(res.Result);
                break;
              case this.formsGlobals.CONTROL_CHECK_BOX:
                if (res.Result === 'true') {
                  result = formItem.cfgDFormItem.Label;
                }
                break;
            }
            if (result.length > 0) {
              this.formResultsString += result + nlcrTokenHtml;
              this.formResultsStringForNotes += result + nlcrToken;
            }
          }

       }








      /*
      if ((formItem.cfgDFormItem.enumFormControlID === this.enumFormControls_Label || formItem.cfgDFormItem.enumFormControlID === this.enumFormControls_Label45)) {
        const childItems = formData.filter(p => p.ParentdataFormItemId?.toLowerCase() === formItem.dataFormItemId?.toLowerCase() && (p.dataFormResults && p.dataFormResults.length > 0));
        // const childItems = formData.filter(p => p.ParentdataFormItemId?.toLowerCase() === '06b666de-25ea-4914-93f9-c1839d11f86f');

        if (childItems && childItems.length > 0) {
          this.formResultsString += '<span style="font-weight: 500; color: var(--tdo-primary);"><b>' + formItem.cfgDFormItem.Label + spaceTokenHtml + '</b></span>';
          this.formResultsStringForNotes += formItem.cfgDFormItem.Label + spaceToken;
          for (const ci of childItems) {
            if (ci.dataFormResults && ci.dataFormResults.length > 0) {
              for (const res of ci.dataFormResults) {
                let result = '';
                switch (ci.cfgDFormItem.enumFormControlID) {
                  case this.formsGlobals.CONTROL_COMBO_LIST:
                  case this.formsGlobals.CONTROL_CHECK_BOX_LIST:
                  case this.formsGlobals.CONTROL_RADIO_LIST:
                    result = this.getEnumDisplay(res.Result);
                    break;
                  case this.formsGlobals.CONTROL_CHECK_BOX:
                    if (res.Result === 'true') {
                      result = ci.cfgDFormItem.Label;
                    }
                    break;
                }
                if (result.length > 0) {
                  this.formResultsString += result + spaceTokenHtml;
                  this.formResultsStringForNotes += result + spaceToken;
                }
              }
            }
          }
        }

      }
      */
    }
  }

  onFormatAsParagraphChange(event: MatCheckboxChange) {
    this.isFormatAsParagraph = event.checked;
    this.parseResults(this.selectedPainFormDataItems);
  }

  checkCharacterOfPainSelected(ValidValueItemId: string) {
    if (this.selectedPainModel && this.selectedPainModel.EndoPainCharacterOfPainJSON) {
      const cop: string[] = JSON.parse(this.selectedPainModel?.EndoPainCharacterOfPainJSON) as string[];
      return cop?.includes(ValidValueItemId);
    }

    return false;
  }

  onCharacterOfPainChange(event: MatCheckboxChange, ValidValueItemId: string) {
    let cop: string[] = JSON.parse(this.selectedPainModel.EndoPainCharacterOfPainJSON) as string[];
    if (!cop) {
      cop = [];
    }
    if (event.checked) {
      const idx = cop.findIndex(p => p === ValidValueItemId);
      if (idx === -1) {
        cop.push(ValidValueItemId);
      }
    } else {
      const idx = cop.findIndex(p => p === ValidValueItemId);
      if (idx !== -1) {
        cop.splice(idx, 1);
      }
    }
    this.selectedPainModel.EndoPainCharacterOfPainJSON = JSON.stringify(cop);
    this.painService.savePainHistory(this.selectedPainModel).subscribe((res) => {
      //
    });
  }

  saveDetail(model: PainEndoDetailDataModel) {
    this.painService.savePainHistoryDetail(model).subscribe((res) => {
      model.PainDetailID = res.PainDetailID;
    });
  }

  onAddClick() {
    const detail = new PainEndoDetailDataModel();
    detail.PainID = this.selectedPainModel.PainID;
    this.selectedPainModel.dataPainEndoDetails.push(detail);
    this.detailTable.updateData(this.selectedPainModel.dataPainEndoDetails);
  }

  save() {
    this.painService.savePainHistory(this.selectedPainModel).subscribe((res) => {
      //
    });
  }

  checkSleuthSelected(ValidValueItemId: string) {
    if (this.selectedPainModel && this.selectedPainModel.EndoPainToothSleuthSeqJSON) {
      const cop: string[] = JSON.parse(this.selectedPainModel?.EndoPainToothSleuthSeqJSON) as string[];
      return cop?.includes(ValidValueItemId);
    }

    return false;
  }

  onSequenceChange(event: MatCheckboxChange, enu: EnumValidValueItemModel) {
    let cop: string[] = JSON.parse(this.selectedPainModel.EndoPainToothSleuthSeqJSON) as string[];
    if (!cop) {
      cop = [];
    }
    if (event.checked) {
      const idx = cop.findIndex(p => p === enu.ValidValueItemId);
      if (idx === -1) {
        cop.push(enu.ValidValueItemId);
      }
    } else {
      const idx = cop.findIndex(p => p === enu.ValidValueItemId);
      if (idx !== -1) {
        cop.splice(idx, 1);
      }
    }
    this.selectedPainModel.EndoPainToothSleuthSeqJSON = JSON.stringify(cop);
    this.painService.savePainHistory(this.selectedPainModel).subscribe((res) => {
      //
    });
  }

  isPainReliefChecked(enu: EnumValidValueItemModel) {
    if (this.selectedPainModel && this.selectedPainModel.EndoPainPainReliefJSON) {
      const cop: string[] = JSON.parse(this.selectedPainModel?.EndoPainPainReliefJSON) as string[];
      return cop?.includes(enu.ValidValueItemId);
    }

    return false;
  }

  onPainReliefChange(event: MatCheckboxChange, enu: EnumValidValueItemModel) {
    let cop: string[] = JSON.parse(this.selectedPainModel.EndoPainPainReliefJSON) as string[];
    if (!cop) {
      cop = [];
    }
    if (event.checked) {
      const idx = cop.findIndex(p => p === enu.ValidValueItemId);
      if (idx === -1) {
        cop.push(enu.ValidValueItemId);
      }
    } else {
      const idx = cop.findIndex(p => p === enu.ValidValueItemId);
      if (idx !== -1) {
        cop.splice(idx, 1);
      }
    }
    this.selectedPainModel.EndoPainPainReliefJSON = JSON.stringify(cop);
    this.painService.savePainHistory(this.selectedPainModel).subscribe((res) => {
      //
    });
  }

  isNonOdontogenicChecked(enu: EnumValidValueItemModel) {
    if (this.selectedPainModel && this.selectedPainModel.EndoPainNonOdontogenicJSON) {
      const cop: string[] = JSON.parse(this.selectedPainModel?.EndoPainNonOdontogenicJSON) as string[];
      return cop?.includes(enu.ValidValueItemId);
    }

    return false;
  }

  onNonOdontogenicChange(event: MatCheckboxChange, enu: EnumValidValueItemModel) {
    let cop: string[] = JSON.parse(this.selectedPainModel.EndoPainNonOdontogenicJSON) as string[];
    if (!cop) {
      cop = [];
    }
    if (event.checked) {
      const idx = cop.findIndex(p => p === enu.ValidValueItemId);
      if (idx === -1) {
        cop.push(enu.ValidValueItemId);
      }
    } else {
      const idx = cop.findIndex(p => p === enu.ValidValueItemId);
      if (idx !== -1) {
        cop.splice(idx, 1);
      }
    }
    this.selectedPainModel.EndoPainNonOdontogenicJSON = JSON.stringify(cop);
    this.painService.savePainHistory(this.selectedPainModel).subscribe((res) => {
      //
    });
  }

  isReferralPatternChecked(enu: EnumValidValueItemModel) {
    if (this.selectedPainModel && this.selectedPainModel.EndoPainReferralPatternsJSON) {
      const cop: string[] = JSON.parse(this.selectedPainModel?.EndoPainReferralPatternsJSON) as string[];
      return cop?.includes(enu.ValidValueItemId);
    }

    return false;
  }

  onReferralPatternChange(event: MatCheckboxChange, enu: EnumValidValueItemModel) {
    let cop: string[] = JSON.parse(this.selectedPainModel.EndoPainReferralPatternsJSON) as string[];
    if (!cop) {
      cop = [];
    }
    if (event.checked) {
      const idx = cop.findIndex(p => p === enu.ValidValueItemId);
      if (idx === -1) {
        cop.push(enu.ValidValueItemId);
      }
    } else {
      const idx = cop.findIndex(p => p === enu.ValidValueItemId);
      if (idx !== -1) {
        cop.splice(idx, 1);
      }
    }
    this.selectedPainModel.EndoPainReferralPatternsJSON = JSON.stringify(cop);
    this.painService.savePainHistory(this.selectedPainModel).subscribe((res) => {
      //
    });
  }

  isOdontEtiologyChecked(enu: EnumValidValueItemModel) {
    if (this.selectedPainModel && this.selectedPainModel.EndoPainOndontogenicWEtiologyJSON) {
      const cop: string[] = JSON.parse(this.selectedPainModel?.EndoPainOndontogenicWEtiologyJSON) as string[];
      return cop?.includes(enu.ValidValueItemId);
    }

    return false;
  }

  onOdontEtiologyChange(event: MatCheckboxChange, enu: EnumValidValueItemModel) {
    let cop: string[] = JSON.parse(this.selectedPainModel.EndoPainOndontogenicWEtiologyJSON) as string[];
    if (!cop) {
      cop = [];
    }
    if (event.checked) {
      const idx = cop.findIndex(p => p === enu.ValidValueItemId);
      if (idx === -1) {
        cop.push(enu.ValidValueItemId);
      }
    } else {
      const idx = cop.findIndex(p => p === enu.ValidValueItemId);
      if (idx !== -1) {
        cop.splice(idx, 1);
      }
    }
    this.selectedPainModel.EndoPainOndontogenicWEtiologyJSON = JSON.stringify(cop);
    this.painService.savePainHistory(this.selectedPainModel).subscribe((res) => {
      //
    });
  }

  onWizardClick() {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    config.data = this.selectedPainModel;
    this.dialog.open(PainHistorySleuthWizardDialogComponent, config).afterClosed().subscribe((res) => {
      if (res) {
        this.selectedPainForm = res;
        this.save();
      }
    });
  }

  onToNote() {
    const noteModel = new TdoNoteSaveModel();
    noteModel.associatedObjects = [];
    const as1 = new TdoNoteAssociatedObject();
    as1.parentObjectName = 'dataPatientCaseWorkItemForms';
    as1.objectId = this.selectedPainForm.dataPatientCaseWorkItemForm.CaseWorkItemFormsId
    noteModel.associatedObjects.push(as1);

    noteModel.text = this.formResultsStringForNotes;

    noteModel.patientId = this.globals.currentPatientId;
    this.noteService.saveNote(noteModel).subscribe((res) => {
      this.messagingService.sendComponentMessage(MessagingConstants.NOTES_REFRESH, '');
    });
  }
}
